import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@material-ui/core";
import { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";

type Props = {
  open: boolean;
  onClose: () => void;
  onSave: (value: string) => void;
  selectedNote?: "note1" | "note2" | "note3" | null;
  index: number;
  value: string;
};

const AddNoteDialog = ({ open, onClose, onSave, selectedNote, index, value }: Props) => {
  const [note, setNote] = useState("");
  const MAX_LENGTH = 500;
  const { getValues, setValue } = useFormContext();

  useEffect(() => {
    if (open && selectedNote) {
      const currentValue = getValues(`rows.${index}.${selectedNote}`);
      if (currentValue === undefined && value) {
        setValue(`rows.${index}.${selectedNote}`, value);
      }

      setNote(currentValue ?? value ?? "");
    }
  }, [open, value, index, selectedNote, getValues]); //eslint-disable-line react-hooks/exhaustive-deps

  const noteTitles = {
    note1: "Jegyzet 1",
    note2: "Jegyzet 2",
    note3: "Jegyzet 3",
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth={"md"}>
      <DialogTitle>
        {selectedNote &&
          `${note ? "Jegyzet szerkesztése" : "Jegyzet hozzáadása"} - ${noteTitles[selectedNote]}`}
      </DialogTitle>
      <DialogContent>
        <Box p={2}>
          <TextField
            fullWidth
            multiline
            rows={4}
            variant="outlined"
            label="Jegyzet hozzáadása"
            value={note}
            onChange={e => setNote(e.target.value)}
            inputProps={{ maxLength: MAX_LENGTH }}
            helperText={`${note.length || 0} / ${MAX_LENGTH}`}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Mégse
        </Button>
        <Button
          onClick={() => {
            onSave(note);
            onClose();
          }}
          color="primary"
          variant="contained"
        >
          Mentés
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddNoteDialog;
